import MultiPageForm from '../../MultiPageForm';
import FormPage from '../../MultiPageForm/FormPage';
import React, { useState, useEffect } from 'react';
import IdentificationPage from './IdentificationPage';
import PatientDetailsPage from './PatientDetailsPage';
import BookingDetailsPage from './BookingDetailsPage';
import AdhocDetailsPage from './AdhocDetailsPage';
import {
    useClientProcedures,
    useClients,
    useConsultTypes, useConsultTypeServiceOptions, useConsultTypeServices,
    useDiseases,
    useDivisionOptions,
    useJobRoles,
    useMedicalRoles,
    useServices,
    useSiteOptions
} from '../../../queries';

const ManualBookingForm = ({
    internalSubmit,
    form,
    handleSubmit,
    prePopulate,
    prePopulatePageIndex,
    valid,
    initialValues,
    setInitialValues,
    values,
    submitting,
    authStore,
}) => {
    const [selectedConsultType, setConsultType] = useState(values?.consult_type);
    const [selectedClient, setClientSelection] = useState(null);
    const [selectedDivision, setDivisionSelection] = useState(null);
    const [selectedJobRole, setJobRoleSelection] = useState(null);
    const [diseaseTypeOptions, setDiseaseTypeOptions] = useState([]);
    const clientsQuery = useClients();
    const consultTypesQuery = useConsultTypes();
    const diseasesQuery = useDiseases();
    const divisionsQuery = useDivisionOptions(selectedClient);
    const jobRolesQuery = useJobRoles(selectedClient);
    const serviceOptionsQuery = useConsultTypeServiceOptions(values?.consult_type);
    const siteOptionsQuery = useSiteOptions(
        selectedClient,
        (divisionsQuery.data ?? []).length > 0,
        selectedDivision
    );

    // NOTE: THIS IS SET TO BEST PRACTICE FOR NOW
    const clientProceduresQuery = useClientProcedures('Best Practice');
    const medicalRolesQuery = useMedicalRoles();

    const onClientChange = (newValue) => {
        const clientSelection = newValue === null ? null : newValue.value;
        setDivisionSelection(null);
        setClientSelection(clientSelection);
    };

    const onDivisionChange = (newValue) => {
        const divisionSelection = newValue === null ? null : newValue.value;
        setDivisionSelection(divisionSelection);
    };

    const onJobRoleChange = (newValue) => {
        const jobRole = newValue === null ? null : newValue.value;
        setJobRoleSelection(jobRole);
    }

    const onConsultTypeChange = (consultType) => {
        const consultTypeSelection = consultType === null ? null : consultType.value;
        setConsultType(consultTypeSelection)
        if (consultTypeSelection === 'chronic_care_consult') {
            const diseaseOptions = diseasesQuery.data
                .filter((disease) => {
                    return disease.condition_category === 'chronic_care';
                })
                .map((disease) => ({
                    id: disease.condition,
                    name: disease.condition,
                }));
            setDiseaseTypeOptions(diseaseOptions);
        } else if (consultTypeSelection === 'workplace_disease_consult') {
            const diseaseOptions = diseasesQuery.data
                .filter((disease) => {
                    return disease.condition_category === 'workplace_disease';
                })
                .map((disease) => ({
                    id: disease.condition,
                    name: disease.condition,
                }));
            setDiseaseTypeOptions(diseaseOptions);
        } else {
            setDiseaseTypeOptions([]);
        }
    };

    const [basePageList, setPageList] = useState([
        'Identification',
        'Patient Details',
        'Booking Details',
    ]);
    const getUpdatedPages = (values) => {
        if (values && values.consult_type === 'adhoc_occupational_health_consult_without_cof') {
            return ['Identification', 'Patient Details', 'Booking Details', 'Adhoc Details'];
        } else {
            return ['Identification', 'Patient Details', 'Booking Details'];
        }
    };

    useEffect(
        ()=>{
            const jobRole = (jobRolesQuery.data??[]).filter(
                (jobRole) => {
                    return jobRole.job_role_id ===  selectedJobRole && jobRole.client_id === selectedClient
                }
            )
            if(jobRole.length > 0 ){
                form.change('medical_role', jobRole[0].medical_role_id);
            }
            else{
                form.change('medical_role', null)
            }
        }, [selectedJobRole, values.role_type, values.client]
    )
        useEffect(
        ()=>{
            setJobRoleSelection(null);
        }, [values.role_type]
    )
    return (
        <MultiPageForm
            internalSubmit={(values)=>{
                internalSubmit(values)
            }}
            prePopulate={prePopulate}
            prePopulatePageIndex={prePopulatePageIndex}
            values={values}
            initialValues={initialValues}
            valid={valid}
            submitting={submitting}
            pageList={basePageList}
            setPageList={setPageList}
            getUpdatedPages={getUpdatedPages}
            setInitialValues={setInitialValues}
        >
            <FormPage children={<IdentificationPage formValues={values} />} />
            <FormPage children={<PatientDetailsPage formValues={values} />} />
            <FormPage
                children={
                    <BookingDetailsPage
                        formValues={values}
                        consultTypes={consultTypesQuery.data ?? []}
                        onConsultTypeChange={onConsultTypeChange}
                        diseaseTypeOptions={diseaseTypeOptions}
                        clients={clientsQuery.data ?? []}
                        clientJobRoles={jobRolesQuery.data ?? []}
                        divisions={divisionsQuery.data ?? []}
                        onClientChange={onClientChange}
                        onDivisionChange={onDivisionChange}
                        onJobRoleChange={onJobRoleChange}
                        siteOptions={siteOptionsQuery.data ?? []}
                        medicalRoleOptions={medicalRolesQuery.data}
                        serviceOptions={serviceOptionsQuery.data ??[]}
                    />
                }
            />
            {values && values.consult_type === 'adhoc_occupational_health_consult_without_cof' ? (
                <FormPage
                    children={
                        <AdhocDetailsPage
                            formValues={values}
                            options={clientProceduresQuery.data ? clientProceduresQuery.data : []}
                        />
                    }
                />
            ) : null}
        </MultiPageForm>
    );
};

export default ManualBookingForm;
